import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_persist_ancillaries_improvements",
  stages: {
    affected: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    go_back: 5
  },
  goals: {},
  defaultStage: 1
});

const trackStages = (isMobile: boolean) => {
  utils.stages.main();
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
};

export default { trackStages, ...utils };
